export const campaignStatus = {
  STATUS_STOP: "stop",
  STATUS_START: "start",
  STATUS_MODERATE: "moderation",
  STATUS_SUSPEND: "pause",
  STATUS_ARCHIVE: "archive",
  STATUS_REJECTED: "reject"
};

export const teaserStatus = {
  STATUS_ACTIVE: "active",
  STATUS_INACTIVE: "inactive",
  STATUS_MODERATE: "moderation",
  STATUS_REJECT: "reject"
};

export const cabinetType = {
  ADVERT: "ADVERT",
  EXCHANGE: "EXCHANGE",
  WEBMASTER: "WEBMASTER"
};

export const CLOSE_POPUP = "CLOSE_POPUP";

export const YA_CHAT_GUID = "62c1f0e7-31cf-48d2-8127-c4e9aa7e15d3";
